module.exports = __webpack_public_path__ + "img/motocycle.b1a13d20.svg";